import { Injectable, inject } from "@angular/core";
import { Auth, authState } from "@angular/fire/auth";
import { getLocalStorage } from "../local-storage";
import { Router } from "@angular/router";
import { iUsuario } from "../usuario/usuario.interface";
import { Store } from "@ngrx/store";
import { firstValueFrom } from "rxjs";
import { AppState } from "../app.state";
import { cargaUsuario } from "../states/usuario/actions";
import { UsuarioService } from "./../usuario/usuario.service";
import { Dialog } from "@angular/cdk/dialog";

@Injectable({
  providedIn: "root",
})
export class ValidLoginService {
  private readonly store: Store<AppState> = inject(Store);
  private usuarioService = inject(UsuarioService);
  private router = inject(Router);
  private auth = inject(Auth);
  private dialog = inject(Dialog);
  authState$ = authState(this.auth);

  constructor() {
    const localStorage = getLocalStorage();
    this.authState$.subscribe((aUser: any | null) => {
      localStorage?.setItem("user", JSON.stringify(aUser));
      if (aUser === null) {
        console.log("constructor ValidLoginService", aUser);
        this.dialog.closeAll();

        this.router.navigate(["login"]);
      } else {
        this.cargaUsuario(aUser.uid);
      }
    });
  }

  async cargaUsuario(uid: string) {
    const oUsuario: any = await firstValueFrom(
      this.usuarioService.getUsuario()
    );
    oUsuario.uid = uid;
    oUsuario.escritura = this.getTemasEscribir(oUsuario);
    oUsuario.lectura = this.getTemasLeer(oUsuario);
    console.log("oUsuario", oUsuario);

    this.store.dispatch(cargaUsuario({ oUsuario }));
  }

  getTemasEscribir(oUsuario: any) {
    let escritura = [];
    for (let key in oUsuario.temas) {
      if (
        oUsuario.temas[key].permiso == 2 ||
        oUsuario.temas[key].permiso == 3
      ) {
        escritura.push(key);
      }
    }
    return escritura;
  }

  getTemasLeer(oUsuario: any) {
    let lectura = [];
    for (let key in oUsuario.temas) {
      if (
        oUsuario.temas[key].permiso == 1 ||
        oUsuario.temas[key].permiso == 3
      ) {
        lectura.push(key);
      }
    }
    return lectura;
  }
}
